import ReactGA from "react-ga";

export function initGA() {
  if (isProduction()) {
    ReactGA.initialize(App.GOOGLE_ANALYTICS);
  }
}

export function event(category, action, label = '') {
  if(isProduction()) {
    ReactGA.event({
      category: category,
      action: action,
      label: label
    });
  }
}

function isProduction() {
  return App.RAILS_ENV === 'production'
}
